module.exports = __webpack_public_path__ + "media/logos/press-logo-attorneys-white-0cecfde5.png";